export default {
      id: "icon-link-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-link",
      toString: function () {
        return this.url;
      }
    }